import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomErrors } from '@asamco/base';
import { bind, isNullOrWhitespace, pathJoin } from '@asamco/utils';
import { DxFileUploaderComponent, DxTextBoxModule, DxFileUploaderModule } from 'devextreme-angular';
import dxFileUploader from 'devextreme/ui/file_uploader';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Application } from '../../../../interfaces/application.interface';
import { ApplicationService } from '../../../../services/application.service';
import { AsValidatorDirective } from '../../../../../../../../base/src/lib/as-validator/as-validator.directive';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
    selector: 'al-application-edit',
    templateUrl: './application-edit.component.html',
    styleUrls: ['./application-edit.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        DxTextBoxModule,
        AsValidatorDirective,
        DxFileUploaderModule,
        AsyncPipe,
    ],
})
export class ApplicationEditComponent implements OnInit {
	@ViewChild(DxFileUploaderComponent)
	uploader: DxFileUploaderComponent;

	public customErrors: CustomErrors = {
		ERROR_REQUIRED: 'This field is required',
	};

	public imgUrl = '';
	public id: number;
	public application$: Observable<Application>;
	public image: any = null;
	public reader = new FileReader();
	public formGroup: FormGroup;

	constructor(private route: ActivatedRoute, private router: Router, private applicationService: ApplicationService) {}

	ngOnInit(): void {
		this.imgUrl = pathJoin([window['deployUrl'], '/assets/img/']);

		this.application$ = this.route.params.pipe(
			map(r => r.id),
			switchMap((id: number) => {
				return this.applicationService.getOne(id).pipe(tap(app => this.formGroup.get('displayName').setValue(app.displayName)));
			})
		);
		this.formGroup = new FormGroup({ displayName: new FormControl('', Validators.required) });
		this.reader.onload = () => {
			this.image = this.reader.result;
		};
	}

	public valueChanged($event) {
		this.image = null;
		if ($event.value[0]) this.reader.readAsDataURL($event.value[0]);
	}

	public getPreviewImage() {
		return this.image;
	}

	public clearImage() {
		this.image = null;
		this.uploader.instance.reset();
	}

	public getUrl(subUrl: string): string {
		if (!isNullOrWhitespace(this.imgUrl) && !isNullOrWhitespace(subUrl)) {
			return pathJoin([this.imgUrl, subUrl]);
		}
		return '';
	}

	public cancel(): void {
		this.router.navigate(['application-link/application']);
	}

	public save(application: Application): void {
		this.formGroup.updateValueAndValidity();
		if (this.formGroup.valid) {
			application.displayName = this.formGroup.get('displayName').value;
			this.applicationService.edit(application.id, this.formGroup.get('displayName').value, this.image).subscribe({error: console.error});
			this.router.navigate(['application-link/application']);
		}
	}
}
